import useAxios from 'axios-hooks';
import { Dayjs } from 'dayjs';
import { ReportType } from 'src/Enum/Report';

export type CreateReportFormValues = {
  startOperatingYear: Dayjs | null;
  endOperatingYear: Dayjs | null;
  companyId: string;
  ICompany: number;
  reportType: ReportType;
};

export type EditReportFormValues = CreateReportFormValues & {
  reportId: number;
};

export interface IReport {
  id: number;
  startOperatingYear: number;
  endOperatingYear?: number;
  reportType: ReportType;
  isVerifyReport: boolean | null;
  committeeVotedDate: string | null;
  publishedDate: string | null;
  companyId: number;
  documentTh: string | null;
  documentEn: string | null;
  createdAt: string;
  updatedAt: string;
  cgrScoreId: number | null;
}

export interface CreateReportPayload {
  startOperatingYear: string | null;
  endOperatingYear: string | null;
  companyId: string;
  ICompany: number;
  reportType: ReportType;
}

export interface IEditReportPayload {
  startOperatingYear: number;
  endOperatingYear: number | null;
  id: number;
  reportType: ReportType;
  companyId: number;
}

export interface IEditReportResponse extends IEditReportPayload {
  isDraftReport: boolean;
  committeeApprovalDate: null;
  publishedDate: null;
  reportSnapData: null;
  createdAt: Date;
  updatedAt: Date;
  iCompany: number;
}

export const useGetReportList = (id: number) => {
  return useAxios<IReport[]>({
    url: `/reports/company/${id}`,
    method: 'GET',
  });
};

export const useCreateReport = (payload?: CreateReportPayload) => {
  return useAxios<IReport>(
    {
      url: `/reports/create`,
      data: payload,
      method: 'POST',
    },
    { manual: true }
  );
};

export const useEditReport = (payload?: IEditReportPayload) => {
  return useAxios<IEditReportResponse>(
    {
      url: `/reports/edit`,
      data: payload,
      method: 'PATCH',
    },
    { manual: true }
  );
};

export const useDeleteReport = (id: number) => {
  return useAxios<IReport>(
    {
      url: `/reports/${id}`,
      method: 'DELETE',
    },
    { manual: true }
  );
};
